import PastIntervalSelector from 'components/elements/PastIntervalSelect';
import { useCreatedAtStart } from 'state/dashboard';

const DateCreatedOverlayFilter = () => {
  const [createdAtStart, setCreatedAtStart] = useCreatedAtStart();

  return (
    <PastIntervalSelector
      placeholder="Date Created"
      aria-label="Date Created Filter"
      value={createdAtStart}
      onChange={setCreatedAtStart}
    />
  );
};

export default DateCreatedOverlayFilter;
